import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SiteState } from '@app/core/store/reducers/site';

const getSitesFeatureState = createFeatureSelector<SiteState>('sites');

export const getSites = createSelector(getSitesFeatureState, (state: SiteState) => state.sites);
export const getSiteDetail = createSelector(getSitesFeatureState, (state: SiteState) => state.siteDetail);
